import { Component, OnInit } from '@angular/core';

import { DEPARTMENT_TYPE_COACHTRAINING } from 'src/app/core/constants';

@Component({
  selector: 'app-coachtraining-home',
  templateUrl: './coachtraining-home.component.html',
  styleUrls: ['./coachtraining-home.component.scss']
})
export class CoachtrainingHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentType: string = DEPARTMENT_TYPE_COACHTRAINING;

  constructor() { }

  ngOnInit(): void {
  }

}
